import { Coins, HelpingHand } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { ModuleBlock } from "../../../ui/Block";
import type { InfoRowItemProps } from "../../../ui/InfoRow";
import type ExpenseModuleModel from "../ExpenseModuleModel";

export const ExpenseModuleBlockUI = observer(
  ({ module }: { module: ExpenseModuleModel }) => {
    const infoRowItems = React.useMemo<InfoRowItemProps[]>(
      () => [
        {
          text: `${module.data.snapshot.totalExpenses ?? 0} expenses`,
          icon: Coins,
        },
        {
          text: `${module.data.snapshot.totalUnsettledDebts ?? 0} debts`,
          icon: HelpingHand,
        },
      ],
      [module.data.snapshot],
    );

    return (
      <ModuleBlock
        module={module}
        infoRowItems={infoRowItems}
        doneText={"All debts have been settled"}
      />
    );
  },
);
